// extracted by mini-css-extract-plugin
export default {"savedTruckContainer":"style_savedTruckContainer__MgFUK","body":"style_body__y8pM7"};